import { FC, HTMLAttributes } from 'react'
import { useAppSelector } from '../../redux'
import { getInitials } from '../../utils'
import { StyledAvatar } from '.'

const Avatar: FC<HTMLAttributes<HTMLDivElement>> = ({ ...rest }) => {
  const { user } = useAppSelector((state) => state.user)

  return (
    <StyledAvatar className="avatar" {...rest}>
      {getInitials(user?.displayName || 'GUEST ACCOUNT')}
    </StyledAvatar>
  )
}

export default Avatar
